import { Injectable } from '@angular/core';

@Injectable()
export class SubmenuToggleTimeoutService {
  private _timeout: ReturnType<typeof setTimeout> | null = null;

  // Delay the toggle to ensure the submenu is fully initialized
  set(value: boolean, callback: () => void, delay = 0): void {
    this.clear();
    if (!value) return;

    this._timeout = setTimeout(callback, delay);
  }

  clear(): void {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }
}
